import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bachelor-of-commerce-degree',
  templateUrl: './bachelor-of-commerce-degree.component.html',
  styleUrls: ['./bachelor-of-commerce-degree.component.scss']
})
export class BachelorOfCommerceDegreeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
